import { Route, Routes, useNavigate } from "react-router-dom";
import { IsAuthenticatedContext } from "auth";

import { PrivateRoute } from "auth";
import * as Pages from "pages";
import { useContext, useEffect } from "react";
import { ChangePassword } from "pages/ChangePassword";
import CallRecord from "pages/CallRecord";

const AppRoutes: React.FC<React.ReactNode> = () => {
  const [isAuthenticated, setIsAuthenticated] = useContext(
    IsAuthenticatedContext
  );
  const navigate = useNavigate();

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleStorageChange = (event: any) => {
      if (
        event.key === "logout" ||
        (event.key === "isLoggedIn" && event.newValue === null)
      ) {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("username");
        navigate("/login");
        window.location.reload();
      }
    };

    const username = localStorage.getItem("username");

    if (!username) {
      if (isAuthenticated) {
        setIsAuthenticated(false);
      }
      navigate("/login");
    }

    window.addEventListener("storage", handleStorageChange);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Pages.Login />} />
      <Route path="/logout" element={<Pages.Logout />} />
      <Route path="/settings" element={<ChangePassword />} />

      <Route path="/" element={<PrivateRoute />}>
        <Route path="" element={<Pages.Users />} />
      </Route>

      <Route
        path="/call-record/:id/:date/Accounts/:aid/Recordings/:rid"
        element={<CallRecord />}
      />

      <Route path="/patients" element={<PrivateRoute />}>
        <Route path="" element={<Pages.Users />} />
      </Route>

      <Route path="/activity-library" element={<PrivateRoute />}>
        <Route path="" element={<Pages.ActivityLibrary />} />
      </Route>

      <Route path="/activity-details/:id/" element={<PrivateRoute />}>
        <Route path="" element={<Pages.ActivityDetails />} />
      </Route>

      <Route path="/patient-details/:id/" element={<PrivateRoute x />}>
        <Route path="" element={<Pages.UserDetails />} />
      </Route>

      <Route
        path="/patient-details/deactivated/:id/"
        element={<PrivateRoute x />}
      >
        <Route path="" element={<Pages.DeactivatedUserDetails />} />
      </Route>

      <Route path="/access-log" element={<PrivateRoute />}>
        <Route path="" element={<Pages.AccessLog />} />
      </Route>

      <Route path="/refresh" element={<PrivateRoute />}>
        <Route path="" element={<Pages.RefreshPage />} />
      </Route>

      <Route
        path=".well-known/cf-2fa-verify.txt"
        element={<p>394ac944ef2bcf6</p>}
      />

      {/* Catch-all route must be the last route inside of the Routes */}
      <Route path="*" element={<Pages.PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
